import { compose, prop } from 'ramda';
import { useNavigate } from 'js/hooks/navigate';
import React, { useCallback, useEffect } from 'react';
import { withComponent } from 'js/components/hocs/withComponent';
import { componentService } from 'js/services/component.service';
import { useComponentConfig } from 'js/hooks/component/useComponentConfig';

import * as hooks from './hooks';
import { Form } from './components/Form';
import { WALLET_LINKING } from './constants';
import { IFrame } from './components/IFrame';
import { useDynamicReducerSelector, withDynamicReducer } from './store';

export const WalletLinkingBare = () => {
    const navigate = useNavigate();
    const { successURL } = useComponentConfig();

    const onSuccess = useCallback(() => {
        navigate(successURL);
    }, [navigate, successURL]);

    const fetchPlayerTags = hooks.useFetchPlayerTags();
    const onSubmit = hooks.useOnSubmit({ onSuccess });
    const openUrl = useDynamicReducerSelector(prop('openUrl'));

    useEffect(() => {
        fetchPlayerTags();
    }, [
        fetchPlayerTags
    ]);

    if (openUrl) {
        return <IFrame src={openUrl} onSuccess={onSuccess} />;
    }

    return <Form onSubmit={onSubmit} />;
};

export const WalletLinking = compose(
    withComponent({ isForLoggedIn: true }),
    withDynamicReducer()
)(WalletLinkingBare);

componentService.registerPageComponents({ [WALLET_LINKING]: WalletLinking });
